(function() {
  'use strict';
  angular.module('benefits')
    .filter('accumType', function() {
      var types = new Map();
      types.set("maximum", "Maximums");
      types.set("deductible", "Deductible");
      types.set("outOfPocket", "Out of Pocket");
      types.set("benefitPeriod", "Benefit Period");
      types.set("lifetime", "Lifetime");
      return function(accum) {
        if(!accum.type || !accum.unit) {
          return "";
        } else {
          return types.get(accum.type) + ' - ' + types.get(accum.unit);
        }
      };
    });
})();
